import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sun, Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import api from "../lib/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const formatError = (detail) => {
    if (!detail) return "Inloggen mislukt";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
    return String(detail);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("hb_admin_token", data.token);
      localStorage.setItem("hb_admin_email", data.email);
      toast.success("Welkom terug");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-50 p-5" data-testid="admin-login-page">
      <div className="absolute top-0 left-0 right-0 h-1/2 bg-gradient-to-b from-brand-soft/50 to-transparent" />
      <div className="relative w-full max-w-md bg-white border border-slate-200 rounded-3xl shadow-[0_30px_80px_rgba(15,23,42,0.12)] p-8">
        <div className="flex items-center gap-2 mb-7">
          <div className="w-9 h-9 rounded-full gradient-pink flex items-center justify-center">
            <Sun className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-heading font-black text-xl text-navy-900">Helios Bright</span>
        </div>
        <h1 className="font-heading text-3xl font-black text-navy-900 mb-2">Admin login</h1>
        <p className="text-slate-600 mb-7">Toegang tot het lead dashboard.</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-sm font-semibold text-navy-900 mb-2 block">E-mailadres</label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl h-12 border-slate-200" data-testid="admin-email" />
          </div>
          <div>
            <label className="text-sm font-semibold text-navy-900 mb-2 block">Wachtwoord</label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl h-12 border-slate-200" data-testid="admin-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-pink w-full !py-4 disabled:opacity-60" data-testid="admin-login-submit">
            {loading ? "Inloggen..." : (<><Lock size={16} /> Inloggen</>)}
          </button>
        </form>
      </div>
    </main>
  );
};

export default AdminLogin;
